import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { toast } from "@grandvisionhq/common";
import { PaymentMethod, Hooks } from "@grandvisionhq/payments";
import { useHandleOrderCreation } from "./useHandlerOrderCreation.js";
import { useValidateAndSetOrderDetails } from "./useValidateAndSetOrderDetails.js";
const useHandlePaypalConfig = ({
  selectedPaymentMethod,
  selfUrl,
  donationInfo,
  consents,
  selectedShippingMethod,
  isSaveDetailsInAccount = false,
  setIsOrderInProgress
}) => {
  const { cart } = Context.useCart();
  const { saveCustomerInformation } = useValidateAndSetOrderDetails();
  const { handlePlaceOrder } = useHandleOrderCreation();
  const createPaypalOrder = React.useCallback(
    (paypalOrderId) => {
      setIsOrderInProgress(true);
      handlePlaceOrder({
        selectedPaymentMethod,
        paymentDetails: {
          isValid: true,
          type: PaymentMethod.PAYPAL,
          data: {
            referenceId: paypalOrderId
          }
        },
        selfUrl,
        consents,
        donationInfo,
        isSaveDetailsInAccount,
        setIsOrderInProgress
      });
    },
    [
      handlePlaceOrder,
      selectedPaymentMethod,
      selfUrl,
      consents,
      donationInfo,
      isSaveDetailsInAccount,
      setIsOrderInProgress
    ]
  );
  const handlePaypalCtaClick = React.useCallback(
    async (_, actions) => {
      return await saveCustomerInformation(selectedShippingMethod, consents).then(({ success }) => {
        if (success) {
          return actions.resolve();
        }
        throw Error("FailedToSaveCustomerDetails");
      }).catch(() => {
        return actions.reject();
      });
    },
    [consents, saveCustomerInformation, selectedShippingMethod]
  );
  const paypalPaymentEvents = Hooks.useCreatePaypalPaymentEvents({
    hasSubscription: Boolean(cart?.hasSubscription),
    cartId: typeof cart?.id === "string" ? cart?.id : "",
    onPaymentAuthorization: createPaypalOrder
  });
  const onPaypalError = () => {
    toast.failed("checkout.errors.general.message");
  };
  return {
    handlePaypalCtaClick,
    onPaypalError,
    paypalPaymentEvents
  };
};
export {
  useHandlePaypalConfig
};
//# sourceMappingURL=useHandlePaypalConfig.js.map
